var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{class:{'is-short': _vm.isShort},attrs:{"outlined":_vm.isOutlined,"type":_vm.color,"size":_vm.size,"icon-left":_vm.iconLeft,"icon-right":_vm.iconRight,"loading":_vm.loading || _vm.asyncLoading,"disabled":_vm.asyncLoading || _vm.disabled},on:{"click":_vm.clicked}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }